import "./NeuesPasswort.css";
import BisPasswordfield from "../components/bisPaswordfield/BisPasswordfield";
import {useEffect, useState} from "react";
import BisButton from "../components/bisButton/BisButton";
import BisCard from "../components/bisCard/BisCard";
import Title from "../components/title/Title";

function NeuesPasswort({username, passwordOld, onBack}) {
    return (
        <div className="neues-passwort-container">
            <BisCard child={
                <NeuesPasswortContent
                    username={username}
                    passwordOld={passwordOld}
                    onBack={onBack}/>
            }/>
        </div>
    );
}

function NeuesPasswortContent({username, passwordOld, onBack}) {
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');
    const [newPasswordConfirmError, setNewPasswordConfirmError] = useState('');

    const validateInput = () => {
        let valid = true;

        if (!newPassword) {
            setNewPasswordError("Bitte geben Sie ein Passwort ein");
            valid = false;
        } else {
            setNewPasswordError("");
        }

        if (!newPasswordConfirmation) {
            setNewPasswordConfirmError("Bitte bestätigen Sie das Passwort");
            valid = false;
        } else {
            setNewPasswordConfirmError("");
        }

        return valid;
    };

    const validatePassword = async () => {
        const response = await fetch(`${window.location.origin}/bis-login2/validate-password`, {
            method: 'POST',
            credentials: "include",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({newPassword, newPasswordConfirmation}),
        });

        const data = await response.json();

        if (!response.ok || (data.errorCode && data.errorCode !== 0)) {
            return {success: false, errorCode: data.errorCode};
        }

        return {success: true};

    };

    const onPasswordConfirmClick = async (e) => {
        e.preventDefault();

        if (!validateInput()) return;

        const result = await validatePassword();

        if (!result.success) {

            const msg = getMessageFromCode(result.errorCode);
            console.log(msg);

            setNewPasswordError(msg);

            const pwField = document.getElementById('newPassword');
            if (pwField) {
                pwField.focus();
            }

        } else {
            const response = await fetch(`${window.location.origin}/bis-login2/change-password`, {
                method: 'POST',
                credentials: "include",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    username: username,
                    passwordOld: passwordOld,
                    passwordNew: newPassword
                })
            });

            const data = await response.json();

            if (!response.ok) {
                console.log(data.error);
                console.log("Fehler");
            }

            console.log(data.url)

            window.location.href = data.url;
        }
    };

    const getMessageFromCode = (errorCode) => {

        switch (errorCode) {
            case 1:
                return "Das neue Passwort muss ein anderes als das aktuelle sein"
            case 2:
                return "mind. 12 Zeichen"
            case 3:
                return "enthält keinen Kleinbuchstaben"
            case 4:
                return "enthält keinen Großbuchstaben"
            case 5:
                return "enthält keine Zahl"
            case 6:
                return "enthält kein Sonderzeichen"
            case 7:
                return "darf keine Leerzeichen enthalten"
            case 8:
                return "Passwörter stimmen nicht überein"
            case 9:
                return "max. 50 Zeichen"
            default:
                return "Unbekannter Fehler"
        }

    }

    useEffect(() => {
        if (newPasswordError) {
            document.getElementById('newPassword').focus();
        }
    }, [newPasswordError]);

    return (
        <form className="neuesPasswortContent-container">
            <Title text="Neues Passwort setzen"/>

            <div className="password-policy">
                <p>
                    Mindestanforderungen an das Passwort:
                    <ul>
                        <li>Mindestlänge 12 Zeichen</li>
                        <li>Maximallänge 50 Zeichen</li>
                        <li>mindestens einen Großbuchstaben</li>
                        <li>mindestens ein Kleinbuchstaben</li>
                        <li>mindestens eine Zahl</li>
                        <li>mindestens ein Sonderzeichen: !&quot;#$%&amp;()¿.*+,-/:;&lt;=&gt;?_</li>
                    </ul>
                </p>
            </div>

            <BisPasswordfield
                id="newPassword"
                label="Neues Passwort"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                error={newPasswordError}
                aria-invalid={newPasswordError ? "true" : "false"}
                aria-describedby={newPasswordError ? "newPassword-error" : undefined}
                className="newpwfield"
            />

            <BisPasswordfield
                id="newPasswordConfirm"
                label="Passwort bestätigen"
                value={newPasswordConfirmation}
                onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                error={newPasswordConfirmError}
                aria-invalid={newPasswordConfirmError ? "true" : "false"}
                aria-describedby={newPasswordConfirmError ? "newPasswordConfirm-error" : undefined}
                className="newpwfield"
            />

            <BisButton
                id="btn-password-confirm"
                className="btn-password-confirm"
                onClick={onPasswordConfirmClick}
                aria-label="Neues Passwort übernehmen"
                text="Neues Passwort übernehmen"
            />

            <BisButton
                id="btn-back-to-login"
                className="btn-back-to-login"
                onClick={onBack}
                aria-label="Zurück zur Anmeldung"
                text="Zurück zur Anmeldung"
            />
        </form>
    );
}

export default NeuesPasswort;
